import { useFlag } from '@unleash/proxy-client-react';
import { getFeatureLocalOverride } from '../features/feature-enablement/featureEnablement';
import { FeatureId } from '../features/feature-enablement/features';
import { unleashClient } from './Unleash';

/** @deprecated Use `useIsFeatureEnabled` instead */
export const useFeatureFlag = (name: FeatureId) =>
  getFeatureFlagValue(name, useFlag);

/**
 * @deprecated Use `isFeatureEnabled` instead
 * This function is intended for use outside of React,
 * for example in epics.
 */
export const isFeatureFlagEnabled = (name: FeatureId, useOverrides = true) =>
  getFeatureFlagValue(name, n => unleashClient.isEnabled(n), useOverrides);

const getFeatureFlagValue = (
  name: FeatureId,
  readFromUnleash: (name: string) => boolean,
  useOverrides = true
) => {
  // It's important that readFromUnleash is always called the same number of times,
  // otherwise we can break the rules of hooks (if called from useFeatureFlag).
  const valueFromUnleash = readFromUnleash(name);
  const antivalueFromUnleash = readFromUnleash(`anti-${name}`);
  const override = useOverrides ? getFeatureLocalOverride(name) : undefined;

  return override ?? (valueFromUnleash && !antivalueFromUnleash);
};
